import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/home/tip_icon_1.png'
import _imports_1 from '@/assets/images/common/btn_close.png'
import _imports_2 from '@/assets/images/home/convert_icon.png'


const _hoisted_1 = {
  key: 0,
  class: "vip0-charge"
}
const _hoisted_2 = { class: "charge-contain" }
const _hoisted_3 = { class: "charge-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "charge-msg-box display-column display-y-center display-s-b" }
const _hoisted_6 = { class: "amount" }
const _hoisted_7 = { class: "amount-des" }
const _hoisted_8 = { class: "btn-content display-y-center display-x-center" }
const _hoisted_9 = {
  key: 1,
  class: "tip-content tip-1 item-center"
}
const _hoisted_10 = { class: "title display-y-center display-x-center" }
const _hoisted_11 = { class: "content-bg" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "icons" }
const _hoisted_14 = { class: "btn-1 display-column display-y-center display-x-center" }
const _hoisted_15 = { class: "amount" }
const _hoisted_16 = { class: "amount-des" }
const _hoisted_17 = { class: "btn-content display-y-center display-x-center" }

import { useStore } from 'vuex';
import ModalTemplate from '../common/ModalTemplate.vue';
import { useI18n } from 'vue-i18n';
import { getGold } from '@/utils/currencyUtils';
import { toCharge } from '@/handle/balanceHandle';
import { getSessionData } from '@/handle/sessionHandle';
import { CHANNEL_CONFIG, SESSION_STORE } from '@/config/constConfig';
import VIPItem from '../common/VIPItem.vue';
import { currentChannel, currentVip2ChargeNum, currentVipChargeNum } from '@/config/config';
import router from '@/router';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CashBackTip',
  props: {
        visible: {
            type: Boolean,
            default: false,
        }
    },
  setup(__props) {

const props = __props;

    const store = useStore();
    const { t } = useI18n();

    /**前往商城*/
    function onCharge(amount: number) {
        store.state.isShowCashBackTip = false;
        if (currentChannel.channel == CHANNEL_CONFIG.ID) {
            router.push("deposit");
            return ;
        }
        let params = {
            gold: amount,
            chargeEvent: 0,
        }
        toCharge(params);
    }

    function onCloseCashBackTip() {
        store.state.isShowCashBackTip = false;
        let info: any = getSessionData(SESSION_STORE.ACCOUNT_INFO.key);
        if (info && info.chargeNum <= 3) {
            store.state.isShowCashBackProp = true;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTemplate, { visible: __props.visible }, {
    default: _withCtx(() => [
      (_unref(store).state.accountInfo.vipLevel == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              class: "charge-bg",
              src: _imports_0
            }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "charge-msg",
                  innerHTML: _unref(t)('prop.35')
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getGold)(_unref(store).state.accountInfo.gold)), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("prop.36")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "btn-2 display-y-center display-x-center",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onCharge(_unref(currentVipChargeNum))))
                }, _toDisplayString(_unref(t)("prop.37", { amount: _unref(getGold)(_unref(currentVipChargeNum)) })), 1)
              ])
            ]),
            _createElementVNode("img", {
              class: "btn-close",
              src: _imports_1,
              onClick: onCloseCashBackTip
            })
          ]))
        : (_unref(store).state.accountInfo.withdrawNum == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("common.1")), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  innerHTML: _unref(t)('prop.38')
                }, null, 8, _hoisted_12),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(VIPItem, {
                    style: {"transform":"scale(0.5)"},
                    "vip-level": _unref(store).state.accountInfo.vipLevel
                  }, null, 8, ["vip-level"]),
                  _cache[3] || (_cache[3] = _createElementVNode("img", {
                    class: "vip-icon-2",
                    src: _imports_2
                  }, null, -1)),
                  _createVNode(VIPItem, {
                    style: {"transform":"scale(0.6)"},
                    "vip-level": _unref(store).state.accountInfo.vipLevel + 1
                  }, null, 8, ["vip-level"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(getGold)(_unref(currentVip2ChargeNum))) + " + " + _toDisplayString(_unref(getGold)(_unref(store).state.accountInfo.gold)), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("prop.36")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: "btn-2 display-y-center display-x-center",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onCharge(_unref(currentVip2ChargeNum))))
                }, _toDisplayString(_unref(t)("prop.37", { amount: _unref(getGold)(_unref(currentVip2ChargeNum)) })), 1)
              ]),
              _createElementVNode("img", {
                class: "btn-close",
                src: _imports_1,
                onClick: onCloseCashBackTip
              })
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})